<template>
  <div id="home">
    <div class="home">
      <AppHeader />
      <h1>{{ this.pageTitle }}</h1>
      <router-link
        :to="descriptionLink"
        style="font-size: 20px;font-weight:bolder;"
        target="_blank"
      >Learn more</router-link>
      <div ref="home" style="padding-bottom:40px;">
        <div class="row parentGrid">
          <div class="col">
            <div v-bind:style="{ color: sections.filter( (section) => section.id == 1)[0].color }">
              <h3>{{ sections.filter( (section) => section.id == 1)[0].name }}</h3>
            </div>
            <TodoList :pageID="this.pageID" :propSectionID="1" />
          </div>
          <div class="verticalLine"></div>
          <div class="col">
            <div v-bind:style="{ color: sections.filter( (section) => section.id == 2)[0].color }">
              <h3>{{ sections.filter( (section) => section.id == 2)[0].name }}</h3>
            </div>
            <TodoList :pageID="this.pageID" :propSectionID="2" />
          </div>
        </div>
        <hr />
        <div class="row">
          <div class="col">
            <div v-bind:style="{ color: sections.filter( (section) => section.id == 3)[0].color }">
              <h3>{{ sections.filter( (section) => section.id == 3)[0].name }}</h3>
            </div>
            <TodoList :pageID="this.pageID" :propSectionID="3" />
          </div>
          <div class="verticalLine"></div>
          <div class="col">
            <div v-bind:style="{ color: sections.filter( (section) => section.id == 4)[0].color }">
              <h3>{{ sections.filter( (section) => section.id == 4)[0].name }}</h3>
            </div>
            <TodoList :pageID="this.pageID" :propSectionID="4" />
          </div>
        </div>
      </div>

      <div class="col download">
        <button
          v-show="!showSaveImageButton"
          @click="saveAsImage"
          class="btn btn-outline-success download-btn"
        >Save as Image</button>
        <button @click="saveAsMarkdown" class="btn btn-outline-info download-btn">Save as Markdown</button>
        <button @click="saveAsDoc" class="btn btn-outline-danger download-btn">Save as Doc</button>
        <button @click="saveAsPDF" class="btn btn-outline-primary download-btn">Save as Pdf</button>
      </div>
    </div>
    <a href="#" id="image-download" download="taski.png">Download</a>
    <AppFooter />
  </div>
</template>

<script>
// @ is an alias to /src
import AppHeader from "@/components/AppHeader.vue";
import AppFooter from "@/components/AppFooter.vue";
import TodoList from "@/components/TodoList.vue";
import HelloWorld from "@/components/HelloWorld.vue";

import html2canvas from "@trainiac/html2canvas";
import * as htmlToImage from "html-to-image";
import { saveAs } from "file-saver";
import jsPDF from "jspdf";

import { Document, Header, Packer, Paragraph, HeadingLevel } from "docx";

function download(filename, text) {
  var element = document.createElement("a");
  element.setAttribute(
    "href",
    "data:text/plain;charset=utf-8," + encodeURIComponent(text)
  );
  element.setAttribute("download", filename);
  element.style.display = "none";
  document.body.appendChild(element);
  element.click();
  document.body.removeChild(element);
}

export default {
  name: "Eisen",
  data() {
    return {
      pageID: 1
    };
  },
  created() {
    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 200);
  },
  computed: {
    pageTitle() {
      return this.$store.getters.page(this.pageID)[0].title;
    },
    descriptionLink() {
      return this.$store.getters.page(this.pageID)[0].description_link;
    },
    todos() {
      return this.$store.getters.page(this.pageID)[0].todos;
    },
    sections() {
      return this.$store.getters.page(this.pageID)[0].sections;
    },
    showSaveImageButton() {
      // Opera 8.0+
      var isOpera =
        (!!window.opr && !!opr.addons) ||
        !!window.opera ||
        navigator.userAgent.indexOf(" OPR/") >= 0;

      // Firefox 1.0+
      var isFirefox = typeof InstallTrigger !== "undefined";

      // Safari 3.0+ "[object HTMLElementConstructor]"
      var isSafari =
        /constructor/i.test(window.HTMLElement) ||
        (function(p) {
          return p.toString() === "[object SafariRemoteNotification]";
        })(
          !window["safari"] ||
            (typeof safari !== "undefined" && safari.pushNotification)
        );

      // Internet Explorer 6-11
      var isIE = /*@cc_on!@*/ false || !!document.documentMode;

      // Edge 20+
      var isEdge = !isIE && !!window.StyleMedia;

      // Chrome 1 - 79
      var isChrome =
        !!window.chrome &&
        (!!window.chrome.webstore || !!window.chrome.runtime);

      // Edge (based on chromium) detection
      var isEdgeChromium = isChrome && navigator.userAgent.indexOf("Edg") != -1;

      if (isFirefox || isSafari) {
        return true;
      }
      return false;
    }
  },
  components: {
    AppHeader,
    AppFooter,
    TodoList,
    HelloWorld
  },
  methods: {
    saveAsImage() {
      var title = this.pageTitle.trim();
      htmlToImage
        .toPng(this.$refs.home, { backgroundColor: "#fff" })
        .then(function(dataUrl) {
          var link = document.createElement("a");
          link.download = "taski-" + title + ".png";
          link.href = dataUrl;
          link.click();
        });
    },
    saveAsMarkdown() {
      var title = this.pageTitle.trim();
      var content = `# ` + title + `\n\n`;
      for (var ind = 0; ind < this.sections.length; ind++) {
        content += `\n## ` + this.sections[ind].name + `\n\n`;
        let todos = this.$store.getters.getTodosBySectionID(
          this.pageID,
          this.sections[ind].id
        );
        for (var it = 0; it < todos.length; it++) {
          let isDone = todos[it].isDone ? `&#9745;` : `&#9744;`;
          content += isDone + todos[it].title + `\n`;
        }
      }
      content += "\n\n Built with usetaski.com";
      download("taski-" + title + ".md", content);
    },
    saveAsDoc() {
      const doc = new Document();
      var title = this.pageTitle.trim();
      let todoList = [];
      // let sectionChildren = [];
      for (var ind = 0; ind < this.sections.length; ind++) {
        let todos = this.$store.getters.getTodosBySectionID(
          this.pageID,
          this.sections[ind].id
        );
        todoList.push(
          new Paragraph({
            text: "\n\n" + this.sections[ind].name + "\n",
            heading: HeadingLevel.HEADING_2
          })
        );
        for (var it = 0; it < todos.length; it++) {
          let paragraph = new Paragraph({
            text: todos[it].title,
            heading: HeadingLevel.HEADING_3,
            bullet: {
              level: 0
            }
          });
          todoList.push(paragraph);
        }
      }
      doc.addSection({
        headers: {
          default: new Header({
            children: [
              new Paragraph({
                text: title,
                heading: HeadingLevel.HEADING_1
              })
            ]
          })
        },
        children: todoList
      });
      doc.addSection({
        headers: {
          default: new Header({
            children: [
              new Paragraph({
                text: "\n\n Built with usetaski.com"
              })
            ]
          })
        },
        children: todoList
      });
      Packer.toBlob(doc).then(blob => {
        saveAs(blob, "taski-" + title + ".docx");
      });
    },
    saveAsPDF() {
      var doc = new jsPDF("p", "pt", "a4");
      var title = this.pageTitle.trim();
      var content = title + `\n\n`;
      for (var ind = 0; ind < this.sections.length; ind++) {
        content += `\n` + this.sections[ind].name + `\n\n`;
        let todos = this.$store.getters.getTodosBySectionID(
          this.pageID,
          this.sections[ind].id
        );
        for (var it = 0; it < todos.length; it++) {
          let isDone = todos[it].isDone ? `Done - ` : `- `;
          content += isDone + todos[it].title + `\n`;
        }
      }
      content += "\n\n Built with usetaski.com";
      doc.setFont("Helvetica", "");
      doc.text(content, 50, 50);
      doc.save("taski-" + title + ".pdf");
    }
  }
};
</script>

<style scoped>
.home {
  position: relative;
  margin: 0;
  padding-bottom: 4em;
  min-height: 100%;
}

.verticalLine {
  border-left: 1px solid rgb(189, 189, 189);
}

hr {
  background-color: rgb(189, 189, 189);
}

.parentGrid {
  height: auto;
  margin-top: 2em;
}

.download {
  margin-top: 2em;
}

.download-btn {
  margin: 5px 10px;
}

#image-download {
  display: none;
}
</style>